module.exports = __webpack_public_path__ + "img/game-icon-03.385eab5d.png";